import $ from 'jquery';
const stringToHex = (str) => {
  let hex = '';
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);
    const hexValue = charCode.toString(16);

    // Pad with zeros to ensure two-digit representation
    hex += hexValue.padStart(2, '0');
  }
  return hex;
};
const hexToString = (hex) => {
  let str = '';
  for (let i = 0; i < hex.length; i += 2) {
    const hexValue = hex.substr(i, 2);
    const decimalValue = parseInt(hexValue, 16);
    str += String.fromCharCode(decimalValue);
  }
  return str;
};
const validateInput=(e)=>{
	  
	  let  _emR = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	  
	  let _v=e.target.value;
	  let _t=e.target.type;
	  let _id=e.target.id; //console.log(_id);
	  let _inp=$("#"+_id); //console.log(_id+"=>"+_inp.val());
	  let _check=_inp.attr("check")?_inp.attr("check").toLowerCase():"";
	  
	  if(_inp.attr("minLen") && _v.length<parseInt(_inp.attr("minLen"))){
		  _inp.addClass("form-control-error");
		  return;
		}else{
			_inp.removeClass("form-control-error");
		}
	
	  switch(_check){
		case "email":
			_emR = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if(!_emR.test(_v)) {_inp.addClass("form-control-error"); }
			else {_inp.removeClass("form-control-error");}
				break;
		case "alphanumeric":
			_emR = /^[a-zA-Z0-9]+$/;
			if(!_emR.test(_v)) {_inp.addClass("form-control-error"); }
			else {_inp.removeClass("form-control-error");}
				break;
		case "digit":
			_emR = /^[0-9]+$/;
			if(!_emR.test(_v)) {  _inp.addClass("form-control-error"); }
			else {_inp.removeClass("form-control-error");}
				break;	
		case "textonly":
			_emR = /^[a-zA-Z ]+$/;
			
			if(!_emR.test(_v)) { _inp.addClass("form-control-error"); }
			else {_inp.removeClass("form-control-error");}
				break;
		case "password":
			_emR = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&^])[A-Za-z\d@.#$!%*?&]{8,64}$/
			if(!_emR.test(_v)) {_inp.addClass("form-control-error"); }
			else {_inp.removeClass("form-control-error");}
				break;			
		case "yyyy-mm-dd":
			_emR = /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;
			if(!_emR.test(_v)) {_inp.addClass("form-control-error"); }
			else {_inp.removeClass("form-control-error");}
				break;			
		default:	
		  
	  };
  };
  const validateAllUIInputs=()=>{
	let redBoxes=$(".jform-control,.jform-select");
	for(let i=0;i<redBoxes.length;i++){
		let e={
				target:{id:redBoxes[i].id,
					type:redBoxes[i].type,
					value:redBoxes[i].value
				}
		};
		validateInput(e);
	}  
	  
  };
  const validateToken=(_status)=>{
	if(_status==-402){
		document.location="/login";
	}
  }
 export {validateInput,validateAllUIInputs,stringToHex,hexToString,validateToken};